import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Form, Container, Col, Row, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { handleChange } from "../redux/userSlice";
import { useDispatch } from "react-redux";
import authFetch from "../axios";
import { STEP, SUCCESS_STATUS_DIGIT } from "../utils";

const ResumeApplicationModal = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [appNum, setAppNum] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleHide = () => {
    setShowOtp(false);
    setOtp("");
    setLoading(false);
    onHide();
  };

  const handleResume = async (e) => {
    e.preventDefault();
    sessionStorage.clear();
    setLoading(true);
    try {
      var jsonData = {
        email: email,
        code: appNum,
      };

      var config = {
        method: "post",
        url: `/auth/validate-code`,
        data: jsonData,
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await authFetch(config);
      console.log(data);
      if (data.palliative.status === SUCCESS_STATUS_DIGIT.SUCCESS) {
        setLoading(false);
        setShowOtp(true);
        toast.success("OTP has been sent to your email", {
          position: "top-right",
        });
      } else {
        setLoading(false);
        toast.error("Invalid access code or email", {
          position: "top-left",
        });
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      toast.error("Please retry", {
        position: "top-left",
      });
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      var jsonData = {
        code: appNum,
        otp: otp,
      };

      var config = {
        method: "post",
        url: `/auth/verify-code-otp`,
        data: jsonData,
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await authFetch(config);
      console.log(data);
      if (
        data.palliative.status === SUCCESS_STATUS_DIGIT.SUCCESS &&
        data.palliative.token
      ) {
        sessionStorage.setItem("userToken", data.palliative.token);
        dispatch(
          handleChange({
            name: "accessCode",
            value: data.palliative.token || "",
          }),
        );

        try {
          var config1 = {
            method: "get",
            url: `/auth/retrive-data`,
          };

          const { data } = await authFetch(config1);
          console.log(data);

          if (
            data.palliative.step === STEP.TEST &&
            data.palliative.test_passed === false
          ) {
            toast.error(
              "Cannot resume application, you have failed this test.",
              {
                position: "top-left",
              },
            );
            setLoading(false);
            return;
          } else {
            setLoading(false);
            sessionStorage.setItem("nin", data.palliative.nin);
            sessionStorage.setItem("access_code", data.palliative.access_code);
            sessionStorage.setItem("testPassed", true);
            sessionStorage.setItem("user-type", data.palliative.usertype);
            sessionStorage.setItem("fname", data.palliative.bio_data.firstname);
            sessionStorage.setItem("lname", data.palliative.bio_data.lastname);
            sessionStorage.setItem("gender", data.palliative.bio_data.gender);
            sessionStorage.setItem("dob", data.palliative.bio_data.dob);
            sessionStorage.setItem(
              "preState",
              data.palliative.residence.state_resid_id || "",
            );
            sessionStorage.setItem(
              "preLga",
              data.palliative.residence.lga_resid_id || "",
            );
            sessionStorage.setItem(
              "preName",
              data.palliative.residence.state_resid || "",
            );
            sessionStorage.setItem(
              "preNameLga",
              data.palliative.residence.lga_resid || "",
            );
            dispatch(
              handleChange({
                name: "preState",
                value: data.palliative.residence.state_resid_id || "",
              }),
            );
            dispatch(
              handleChange({
                name: "preName",
                value: data.palliative.residence.state_resid,
              }),
            );
            dispatch(
              handleChange({
                name: "preLga",
                value: data.palliative.residence.lga_resid_id || "",
              }),
            );
            dispatch(
              handleChange({
                name: "preNameLga",
                value: data.palliative.residence.lga_resid || "",
              }),
            );
            dispatch(
              handleChange({
                name: "usertype",
                value: data.palliative.usertype,
              }),
            );
            dispatch(
              handleChange({
                name: "accessCode",
                value: data.palliative.access_code,
              }),
            );
            dispatch(
              handleChange({
                name: "surname",
                value: data.palliative.bio_data.lastname || "",
              }),
            );
            dispatch(
              handleChange({
                name: "firstname",
                value: data.palliative.bio_data.firstname || "",
              }),
            );
            dispatch(
              handleChange({
                name: "gender",
                value: data.palliative.bio_data.gender || "",
              }),
            );
            dispatch(
              handleChange({
                name: "date",
                value: data.palliative.bio_data.dob || "",
              }),
            );
            dispatch(
              handleChange({ name: "nin", value: data.palliative.nin || "" }),
            );

            if (data.palliative.step === STEP.NOT) {
              navigate("/face-capture");
            } else if (data.palliative.step === STEP.FACE) {
              navigate("/contact");
            } else if (data.palliative.step === STEP.CONTACT) {
              navigate("/test");
            } else if (data.palliative.step === STEP.TEST) {
              navigate("/bio-data");
            } else if (data.palliative.step === STEP.BIODATA) {
              navigate("/residence");
            } else if (data.palliative.step === STEP.RESIDENCE) {
              navigate("/document-upload");
            } else if (data.palliative.step === STEP.COMPLETED) {
              toast.error("you have completed this application.", {
                position: "top-left",
              });
              return;
            }
          }
        } catch (error) {
          setLoading(false);
          console.log(error);
          toast.error("please retry", {
            position: "top-left",
          });
        }
      } else {
        setLoading(false);
        toast.error("Invalid OTP or access code", {
          position: "top-left",
        });
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      toast.error("Please retry", {
        position: "top-left",
      });
    }
  };

  return (
    <Modal
      size="md"
      show={show}
      onHide={handleHide}
      aria-labelledby="example-modal-sizes-title-sm"
    >
      <Modal.Header className="modal-header" closeButton>
        <Container>
          <Row className="text-center">
            <Col sm={12} md={12}>
              <Modal.Title
                id="example-modal-sizes-title-sm"
                className="mx-auto"
              >
                &nbsp;&nbsp;&nbsp;&nbsp;
                {showOtp ? "VERIFY OTP" : "RESUME APPLICATION"}
              </Modal.Title>
            </Col>
          </Row>
        </Container>
      </Modal.Header>
      <Modal.Body>
        {showOtp ? (
          <>
            <p>
              Please enter the One-Time Password (OTP) sent to your email to
              proceed.
            </p>
            <Form className="" onSubmit={handleVerifyOtp}>
              <Form.Group className="mb-3" controlId="otpForm">
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter OTP"
                  className="form_input shadow-none"
                  name="otp"
                  onChange={(e) => setOtp(e.target.value)}
                />
              </Form.Group>
              <button type="submit" className="my-btn">
                VERIFY OTP
              </button>
            </Form>
          </>
        ) : (
          <Form className="" onSubmit={handleResume}>
            <Form.Group className="mb-3" controlId="formBasicCheckbox">
              <Form.Control
                required
                type="text"
                placeholder="Enter Your Application Code"
                className="form_input shadow-none"
                name="app_code"
                onChange={(e) => setAppNum(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Control
                required
                type="email"
                placeholder="Enter Your Email Address"
                className="form_input shadow-none"
                name="email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
            <button type="submit" className="my-btn">
              RESUME APPLICATION
            </button>
          </Form>
        )}

        {loading && (
          <div className="row py-3">
            <div className="col-6  col-md-6 mx-auto">
              <Spinner animation="border" variant="success" />
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ResumeApplicationModal;
